module.exports = __webpack_public_path__ + "media/img/auth/google-fc96da2ff4c5866adf2433631f345989.svg";